(() => {
 'use strict';
 const header = document.getElementById('header');
 const menuButton = document.getElementById('menu-toggle');
 const menu = document.getElementById('menu');
 const backdrop = document.getElementById('menu-backdrop');
 const dialog = document.getElementById('film-dialog');
 const film = document.getElementById('full-film');
 const filmPlay = document.getElementById('film-play');
 const hero = document.getElementById('hero-video');
 const motion = document.getElementById('motion-control');
 const motionLabel = document.getElementById('motion-label');
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 const dataSaving = Boolean(navigator.connection?.saveData);
 const background = [document.getElementById('main'), document.querySelector('.footer'), header.querySelector('.wordmark'), header.querySelector('.header-actions')].filter(Boolean);
 const desktopMenu = window.matchMedia('(min-width: 1001px)');
 const menuRoot = menu.querySelector('[data-menu-root]');
 const menuPanes = [...menu.querySelectorAll('[data-menu-pane]')];
 const menuBack = menu.querySelector('[data-menu-back]');
 const menuContext = menu.querySelector('[data-menu-context]');
 menuContext.dataset.rootLabel = menuContext.textContent;
 let activeMenuSection = '';
 let menuOpen = false;
 let menuOpener = menuButton;
 let heroVisible = true;
 let manuallyPaused = false;
 let manuallyStarted = false;
 const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 40 || document.body.classList.contains('ynd-inner-page'));
 const syncScroll = () => document.body.classList.toggle('no-scroll', menuOpen || Boolean(document.querySelector('dialog[open]')));
 function syncMotion() {
  if (!hero || !motion) return;
  motion.setAttribute('aria-label', hero.paused ? 'Play background film' : 'Pause background film');
  motion.setAttribute('aria-pressed', String(!hero.paused));
  motionLabel.textContent = hero.paused ? 'PLAY FILM' : 'PAUSE FILM';
  motion.querySelector('.motion-symbol').textContent = hero.paused ? '▶' : 'Ⅱ';
 }
 function loadVideo(video) {
  const source = video.querySelector('source');
  if (!source.getAttribute('src')) { source.src = source.dataset.src; video.load(); }
 }
 function canPlayHero() {
  return heroVisible && !document.hidden && !menuOpen && !document.querySelector('dialog[open]') && !manuallyPaused && !reduced.matches && (!dataSaving || manuallyStarted);
 }
 function syncHero() {
  if (!hero) return;
  if (canPlayHero()) {
   loadVideo(hero);
   hero.play().then(() => { if (!canPlayHero()) hero.pause(); }).catch(syncMotion);
  } else hero.pause();
 }
 function focusableMenuItems() {
  return [menuButton, ...header.querySelectorAll('.desktop-nav a, .desktop-nav button'), ...menu.querySelectorAll('button, a')].filter(element => !element.closest('[hidden]') && !element.closest('[inert]') && element.getClientRects().length && !element.disabled);
 }
 function showMenuPane(section, moveFocus = true) {
  activeMenuSection = section;
  const pane = menuPanes.find(element => element.dataset.menuPane === section);
  menuRoot.hidden = Boolean(pane);
  menuPanes.forEach(element => { element.hidden = element !== pane; });
  menuBack.hidden = !pane || desktopMenu.matches;
  menuContext.textContent = pane ? pane.dataset.menuLabel : menuContext.dataset.rootLabel;
  document.querySelectorAll('[data-open-menu], [data-menu-section]').forEach(button => button.setAttribute('aria-expanded', String(menuOpen && button.dataset.openMenu === section || menuOpen && button.dataset.menuSection === section)));
  menu.scrollTop = 0;
  if (moveFocus) {
   const target = desktopMenu.matches ? pane?.querySelector('a, button') : pane ? menuBack : menuRoot.querySelector('button, a');
   target?.focus({preventScroll:true});
  }
 }
 function setMenu(open, focusBack = true, section = desktopMenu.matches ? 'shop' : '') {
  if (open && !menuOpen) menuOpener = document.activeElement;
  menuOpen = open;
  header.classList.toggle('menu-open', open);
  menu.classList.toggle('is-open', open);
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
  menu.inert = !open;
  backdrop.hidden = !open;
  background.forEach(element => { element.inert = open; });
  if (open) showMenuPane(section);
  else document.querySelectorAll('[data-open-menu], [data-menu-section]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  syncScroll(); syncHero();
  if (!open && focusBack) (menuOpener?.isConnected && menuOpener.getClientRects().length ? menuOpener : menuButton).focus({preventScroll:true});
 }
 document.addEventListener('ynd:overlay', () => { syncScroll(); syncHero(); });
 updateHeader();
 window.addEventListener('scroll', updateHeader, {passive:true});
 menuButton.addEventListener('click', () => setMenu(!menuOpen));
 document.querySelectorAll('[data-open-menu]').forEach(button => {
  button.addEventListener('click', () => {
   const samePane = menuOpen && activeMenuSection === button.dataset.openMenu;
   if (menuOpen && !samePane) menuOpener = button;
   setMenu(!samePane, true, button.dataset.openMenu);
  });
  button.addEventListener('keydown', event => {
   if (event.key === 'ArrowDown') { event.preventDefault(); setMenu(true, true, button.dataset.openMenu); }
  });
 });
 menu.querySelectorAll('[data-menu-section]').forEach(button => button.addEventListener('click', () => showMenuPane(button.dataset.menuSection)));
 menuBack.addEventListener('click', () => {
  const previousSection = activeMenuSection;
  showMenuPane('', false);
  menuRoot.querySelector(`[data-menu-section="${previousSection}"]`)?.focus({preventScroll:true});
 });
 desktopMenu.addEventListener('change', () => { if (menuOpen) setMenu(false); });
 menu.querySelector('[data-close-menu]')?.addEventListener('click', () => setMenu(false));
 backdrop.addEventListener('click', () => setMenu(false));
 menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
  setMenu(false, false);
  const targetURL = new URL(a.href, location.href);
  if (targetURL.pathname === location.pathname && targetURL.hash) {
   const target = document.getElementById(targetURL.hash.slice(1));
   target?.focus({preventScroll:true});
  }
 }));
 document.addEventListener('keydown', event => {
  if (!menuOpen) return;
  if (event.key === 'Escape') { event.preventDefault(); setMenu(false); return; }
  if (event.key === 'Tab') {
   const items = focusableMenuItems();
   const current = items.indexOf(document.activeElement);
   const next = current === -1 ? 0 : (current + (event.shiftKey ? -1 : 1) + items.length) % items.length;
   event.preventDefault(); items[next]?.focus();
  }
 });
 if (hero) {
 hero.addEventListener('playing', () => {
  if (!canPlayHero()) { hero.pause(); return; }
  hero.classList.add('ready'); syncMotion();
 });
 hero.addEventListener('pause', syncMotion);
 hero.addEventListener('error', () => { hero.classList.remove('ready'); syncMotion(); });
 motion.addEventListener('click', () => {
  if (hero.paused) { manuallyPaused = false; manuallyStarted = true; }
  else manuallyPaused = true;
  syncHero();
 });
 reduced.addEventListener('change', syncHero);
 document.addEventListener('visibilitychange', syncHero);
 if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting; syncHero(); }, {threshold:.1});
  observer.observe(document.querySelector('.hero'));
 }
 }
 if (filmPlay && dialog && film) {
 filmPlay.addEventListener('click', () => {
  dialog.showModal(); syncScroll(); syncHero();
  loadVideo(film); film.play().catch(() => {});
 });
 document.getElementById('film-close').addEventListener('click', () => dialog.close());
 dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const box = dialog.getBoundingClientRect();
  if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
 });
 dialog.addEventListener('close', () => { film.pause(); syncScroll(); syncHero(); filmPlay.focus({preventScroll:true}); });
 }
 syncMotion(); syncHero();
})();

